import React, { useEffect, useState } from "react";
import FlavorTabShimmer from "./FlavorTabShimmer";
import {
  Button,
  Card,
  CardContent,
  Pagination,
} from "@mui/material";
import { ServiceApi } from "../services/index.service";
import { useSelector } from "react-redux";
export function getImageExtension(url) {
  // Split the URL by '/'
  const urlParts = url.split('/');

  // Get the last part of the URL (which is the filename)
  const filename = urlParts[urlParts.length - 1];

  // Split the filename by '.' to get the name and extension
  const filenameParts = filename.split('.');

  // Get the extension (last part of the filenameParts array)
  const extension = filenameParts[filenameParts.length - 1];


  return extension;
}
export const downloadPreSellImage = (url, ImageName) => {
  const imagePath=`${url}?rand=${Math.floor(Math.random() * 5557654)}`
  fetch(imagePath)
      .then(response => response.blob())
      .then(blob => {
          // Create a temporary anchor element
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;

          // Extract the filename from the URL
          const filename = ImageName;

          // Set the download attribute and filename
          link.setAttribute('download', filename);
          document.body.appendChild(link);

          // Simulate a click on the anchor element to start the download
          link.click();

          // Clean up the temporary anchor element
          link.parentNode.removeChild(link);

          // Set the downloaded image URL to display on the page
          
      })
      .catch(error => {
          console.error('Error downloading image:', error);
      });
 
};
const DMBPreSellBoardsList = ({ store }) => {
  const profileData = useSelector((state) => state);
  const [data, setData] = useState([]);
  const [selectedPage, setSelectedPage] = useState(1);
  const [loading, setLoading] = useState(true);
  const [noimage, setNoImage] = useState("");
  const serviceapi = new ServiceApi();

  useEffect(() => {
    if (store) {
      getPreSellBoardImages();
    }
  }, []);

  const getPreSellBoardImages = async () => {
    setLoading(true);
    const req = {
      role: profileData?.profile?.role,
      user_name: profileData?.profile?.user_name,
      intStoreID: store?.intStoreID,
      bitBannerType: 2,
      includeMandatory:1
    };
    const res = await serviceapi.getPresellStoreLevelOrderList(req)
    const response=res?.data?.filter(i=>i?.bitActive===1)
    setNoImage("");
    setData(response);
    setLoading(false);
  };



  const imageOnLoad = (event) => {
    console.log(`Picture successfully ${event.currentTarget.src} loaded.`);
    if (event.currentTarget.className !== "error") {
      event.currentTarget.className = "success";
      setNoImage("SUCCESS");
    }
  };
  const imageOnError = (event) => {
    event.currentTarget.src = "../assets/images/noimage.jpg";
    event.currentTarget.className = "error";
    setNoImage("FAILURE");
  };

  const handleFullScreen = (UrlValue) => {
    window.open(UrlValue, "_blank");
  };

  const handlePagination = (e, pageVal) => {
    setSelectedPage(pageVal);
  };

  if (loading) {
    return (
      <div className="bg-white grid grid-cols-3 lg:grid-cols-1 gap-4 p-4">
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
        <FlavorTabShimmer />
      </div>
    );
  } else if (!data ||  data?.length === 0) {
    return (
      <CardContent>
        <div
          style={{
            textAlign: "center",
          }}
        >
          Boards are not configured for this store . Kindly contact
          administrator.
        </div>
      </CardContent>
    );
  } else {
    const ImageUrl = data[selectedPage - 1]?.vchBannerURL;
    const banner_name = data[selectedPage - 1]?.vchBannerName;
    // const type = data[selectedPage - 1]?.type;
    // console.log(ImageUrl);
    const extension=getImageExtension(ImageUrl)
    return (
      <div className="p-3">
          <div className="flex justify-between py-1">
            <div>
              <h1 className="text-2xl font-display font-medium leading-tight text-secondary">
                {banner_name}
              </h1>
            </div>
            <div>
              <Pagination
                count={data?.length}
                onChange={(e, page) => handlePagination(e, page)}
                variant="outlined"
                shape="rounded"
              />
            </div>
          </div>
          <Card justify="center" alignItems="center">
          {noimage !== "" && noimage !== "FAILURE" && (
            <CardContent
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              {/* <Button
                variant="outlined"
                onClick={() => downloadPreSellImage(ImageUrl, `${banner_name}.jpg`)}
              >
                Flash Drive
              </Button> */}
              <Button
                variant="outlined"
                onClick={() => downloadPreSellImage(ImageUrl,`${banner_name}.${extension}`)}
              >
                USB Flash Drive
              </Button>
              {/* Removing Streaming Button temporarily */}
              {/* <Button
                variant="outlined"
                onClick={() => handleFullScreen(ImageUrl)}
              >
                Streaming
              </Button> */}
            </CardContent>
          )}
          <img
            src={ImageUrl}
            onLoad={imageOnLoad}
            onError={imageOnError}
            style={{ minHeight: "320px", margin: "auto" }}
            alt="pre-sell board"
          />
          {noimage !== "" && noimage === "FAILURE" && (
            <CardContent>
              <div
                style={{
                  textAlign: "center",
                }}
              >
                Boards are not configured for this store . Kindly contact
                administrator.
              </div>
            </CardContent>
          )}
        
        </Card>
      </div>
    );
  }
};

export default DMBPreSellBoardsList;
